import React, { startTransition, useCallback, useMemo, useState } from 'react';
import { makePath } from 'utils/routes';
import { useLocation } from 'wouter';

import {
  type WorkspaceSettingsTabsType,
  WorkspaceSettingsModal,
} from '../pages/SchemasV2/WorkspaceSettings/WorkspaceSettingsModal';
import { NavButton } from './NavButton';
import { type NavTree, SideNav } from './SideNav';

type PaymentsNavProps = {
  workspaceId: string;
};

export const PaymentsNav = ({ workspaceId }: PaymentsNavProps) => {
  const [location] = useLocation();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [settingsTab, setSettingsTab] =
    useState<WorkspaceSettingsTabsType>('workspace');

  const handleCloseSettings = useCallback(
    () => startTransition(() => setIsSettingsOpen(false)),
    []
  );
  const handleOpenSettings = useCallback(
    () => startTransition(() => setIsSettingsOpen(true)),
    []
  );

  const navTree: NavTree = useMemo(
    () => ({
      invoices: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'invoices']),
          children: 'Invoices',
          active: location.includes('/invoices'),
        },
      },
      users: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'users']),
          children: 'Users',
          active: location.includes('/users'),
        },
      },
      products: {
        props: {
          href: makePath(['w', workspaceId, 'payments', 'products']),
          children: 'Products',
          active: location.includes('/products'),
        },
      },
    }),
    [workspaceId, location]
  );

  return (
    <div className="flex flex-col" data-testid="payments-nav">
      <SideNav listStyle="unordered" navTree={navTree} depth={0} />
      <NavButton
        onClick={() => {
          setSettingsTab('workspace');
          handleOpenSettings();
        }}
        marker="bullet"
        label="Settings"
        isActive={isSettingsOpen}
        testId="payments-nav-settings-button"
      />
      {isSettingsOpen && (
        <WorkspaceSettingsModal
          handleClose={handleCloseSettings}
          defaultTab={settingsTab}
        />
      )}
    </div>
  );
};
